import { theme } from "../../../constants/StyledComponents";
import styled from "styled-components";

export const StyledPageMaintenance = styled.div`
  background-color: ${theme.colors.purple_5};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & .maintenance-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  & .maintenance-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 32px;
  }

  & .maintenance-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    max-width: 500px;
    text-align: center;
  }
`;
